import { useDispatch, useSelector } from "react-redux";
import { Box, Button, InputBase, Modal, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

import { updateSearchDeliverypartner } from "../../Redux/page";
import {
  updateDeliveryDetail,
  updatedeliveryModal,
  updatedeliveryEdit,
} from "../../Redux/deliveryUser";
import { DeliveryTable } from "../../sub_components/delivery_table";

export function DeliveryManagement() {
  const dispatch = useDispatch();

  const modalOpen = useSelector((state) => state.deliveryUser.modal);
  const deliveryDetail = useSelector((state) => state.deliveryUser.deliverydetail);

  const handleSearchChange = (e) => {
    dispatch(updateSearchDeliverypartner(e.target.value));
  };

  const handleOpen = () => {
    // Prepare an empty delivery detail for "Add New"
    dispatch(
      updateDeliveryDetail({
        partner_email: "",
        mobileno: "",
        pan: "",
        aadhar: "",
        driving_licence: "",
        username: "",
        address: "",
        document_img: [],
        partner_image: "",
        KYCstatus: "",
        Userstatus: "",
      })
    );
    dispatch(updatedeliveryEdit(false));
    dispatch(updatedeliveryModal(true));
  };

  const handleClose = () => {
    dispatch(updatedeliveryEdit(false));
    dispatch(updatedeliveryModal(false));
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        width: "100%",
        padding: "30px",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <Typography sx={{ fontSize: "16px", fontWeight: "700", lineHeight: "24px" }}>
          Delivery Partners
        </Typography>
        <Typography sx={{ fontSize: "14px", fontWeight: "500", lineHeight: "22px" }}>
          Manage your delivery partners
        </Typography>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
        <Box
          sx={{
            position: "relative",
            display: "flex",
            width: "324px",
            height: "32px",
            gap: "24px",
          }}
        >
          <InputBase
            sx={{
              backgroundColor: "white",
              height: "32px",
              width: "100%",
              maxWidth: "268px",
              borderRadius: "2px",
              border: "1px solid",
              borderColor: "secondary.border",
              padding: "5px 12px 5px 40px",
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "22px",
              color: "black",
            }}
            onChange={handleSearchChange}
            placeholder="Search username"
          />
          <SearchIcon
            sx={{
              position: "absolute",
              left: "12px",
              top: "5px",
              width: "20px",
              height: "20px",
            }}
          />
        </Box>
        <Button
          variant="contained"
          onClick={handleOpen}
          sx={{ textTransform: "none" }}
        >
          Add New
        </Button>
      </Box>

      <DeliveryTable />

      {/* Simple placeholder modal for delivery partner details.
          This uses the existing Redux `delivery` slice (modal + detail). */}
      <Modal
        open={!!modalOpen}
        onClose={handleClose}
        aria-labelledby="delivery-partner-modal-title"
        aria-describedby="delivery-partner-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "100%",
            maxWidth: 600,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 3,
          }}
        >
          <Typography
            id="delivery-partner-modal-title"
            variant="h6"
            sx={{ mb: 2 }}
          >
            {deliveryDetail?.id ? "Edit Delivery Partner" : "Add Delivery Partner"}
          </Typography>
          <Typography
            id="delivery-partner-modal-description"
            sx={{
              maxHeight: 400,
              overflowY: "auto",
              fontFamily: "monospace",
              fontSize: 12,
              whiteSpace: "pre-wrap",
            }}
          >
            {deliveryDetail
              ? JSON.stringify(deliveryDetail, null, 2)
              : "No details to display."}
          </Typography>

          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2, gap: 1 }}>
            <Button
              variant="outlined"
              onClick={handleClose}
              sx={{ textTransform: "none" }}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}


